export const FETCH_UNIVERSITY_FLOWS = "FETCH_UNIVERSITY_FLOWS";

export const INSERT_UNIVERSITY_FLOW = "INSERT_UNIVERSITY_FLOW";

export const DELETE_UNIVERSITY_FLOW = "DELETE_UNIVERSITY_FLOW";

export const EDIT_UNIVERSITY_FLOW_INFO = "EDIT_UNIVERSITY_FLOW_INFO";


